<template>
  <div class="classification">
    <div class="header">
      <el-form
        ref="formTool"
        :model="formTool"
        :inline="true"
        style="text-align: left"
      >
        <el-form-item prop="name" label="">
          <el-input
            style="width: 150px"
            v-model="formTool.contractName"
            placeholder="请输入合同名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item prop="name" label="">
          <el-input
            style="width: 150px"
            v-model="formTool.coopShopName"
            placeholder="请输入CSO名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item prop="name" label="">
          <el-input
            style="width: 176px"
            v-model="formTool.draftShopName"
            placeholder="请输入医药公司名称"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item prop="name" label="">
          <el-input
            style="width: 150px"
            v-model="formTool.submitter"
            placeholder="请输入提交人"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item prop="name" label="提交时间">
          <el-date-picker
            size="small"
            v-model="formTool.sumitTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="name" label="">
          <el-select
            style="width: 220px"
            size="small"
            placeholder="请选择状态"
            multiple
            clearable
            v-model="formTool.taskStatusList"
          >
            <el-option
              v-for="item in auditStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="getList(1)"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="handleReset">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="handleBatchCheck">批量审核</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="center" style="position: relative">
      <MyTable
        :index="false"
        :selection="true"
        :table-data="tableData"
        :page="page"
        :table-option.sync="tableOption"
        @handleSelectionChange="handleSelectionChange"
        @page-change="getList"
      >
        <template slot="taskStatus" slot-scope="scope">
          <span>{{ status(scope.row.taskStatus) }}</span>
        </template>
        <template slot="subTime" slot-scope="scope">
          <div
            v-if="scope.row.subTime"
            style="display: flex; flex-direction: column"
          >
            <span v-for="(li, i) in scope.row.subTime.split(' ')" :key="i">{{
              li
            }}</span>
          </div>
        </template>
        <template slot="operate" slot-scope="scope">
          <div class="table-op-col">
            <el-link
              type="primary"
              :underline="false"
              size="small"
              @click="handleLook(scope.$index)"
              >查看</el-link
            >
            <el-link
              v-if="scope.row.taskStatus === 6 || scope.row.taskStatus === 10"
              type="primary"
              :underline="false"
              size="small"
              @click="handleCheck(scope.$index)"
              >审核</el-link
            >
          </div>
        </template>
      </MyTable>
    </div>

    <childTaskDetailDlg
      ref="refChildTaskDetailDlg"
      @onRefresh="handleRefresh"
    />
    <batchCheckDlg ref="refBatchCheckDlg" @onConfirm="handleConfirmCheck" />
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import Tabs from "@/components/Tabs";

import childTaskDetailDlg from "@/views/compliance/checkchildtask/dialog/childTaskDetailDlg.vue";
import batchCheckDlg from "@/views/compliance/checkchildtask/dialog/batchCheckDlg.vue";

import {
  contractDoTaskPageForCheck,
  contractDoTaskPlatformAudit,
} from "@/api/compliance/childtask";
import { childTaskHelp } from "@/utils/viewHelp";
import dayjs from "dayjs";
import { contractTargetTaskDetail } from "@/api/compliance/task";

const g_DefaultStatus = [6];

export default {
  components: {
    MyTable,
    Tabs,
    childTaskDetailDlg,
    batchCheckDlg,
  },
  data() {
    return {
      auditStatusList: [],
      formTool: {
        contractName: "",
        coopShopName: "",
        draftShopName: "",
        submitter: "",
        sumitTime: null,
        taskStatusList: g_DefaultStatus,
      },
      tableData: [],
      tableOption: [
        { label: "合同名称", prop: "contractName" },
        { label: "医药公司", prop: "draftShopName" },
        { label: "指标名称", prop: "targetName" },
        { label: "CSO公司", prop: "coopShopName" },
        // { label: "任务编码", prop: "code" },
        { label: "任务名称", prop: "name" },
        { label: "提交人", prop: "createBy" },
        { label: "提交时间", prop: "subTime", width: "100px", slot: true },
        { label: "状态", prop: "taskStatus", slot: true },
        { label: "操作", prop: "operate", slot: true, width: "120px" },
      ],
      page: { total: 10, current: 1, size: 10 },

      selectedList: [], //选中的列表，待导出
    };
  },
  created() {
    for (let key in childTaskHelp.taskStatusList) {
      this.auditStatusList.push({
        value: +key,
        label: childTaskHelp.taskStatusList[key],
      });
    }
    // this.getTaskDetail();
    this.getList(1);
  },
  methods: {
    status(taskStatus) {
      return childTaskHelp.status(taskStatus);
    },
    handleSelectionChange(list) {
      this.selectedList = list;
    },
    handleLook(index) {
      const row = this.tableData[index];

      this.openChildTaskDetail({ action: 3, id: row.id });
    },
    handleCheck(index) {
      const row = this.tableData[index];

      this.openChildTaskDetail({ action: 4, id: row.id });
    },
    handleBatchCheck() {
      if (this.selectedList.length <= 0) {
        this.$message.warning("请选择待审核的数据项！");
        return;
      }
      const taskStatusValus = Object.keys(childTaskHelp.taskStatusList);
      let bRet = this.selectedList.some((item) => {
        return item.taskStatus != taskStatusValus[6];
      });
      if (bRet) {
        this.$message.warning("包含了非平台待审核的数据项！");
        return;
      }
      this.$refs.refBatchCheckDlg.open({ count: this.selectedList.length });
    },
    handleConfirmCheck(params) {
      this.doAudit(params.type, params.reason);
    },
    doAudit(type, reason = "", cb) {
      let status = "";

      status = type === 1 ? "PASS" : "NOT_PASS";
      const idList = this.selectedList.map((item) => item.id);
      const data = {
        idList: idList,
        status: status,
        rejectContent: reason,
      };
      contractDoTaskPlatformAudit(data).then((res) => {
        if (res) {
          this.$refs.refBatchCheckDlg.close();
          this.handleRefresh();
        }
      });
    },
    openChildTaskDetail({ action, id }) {
      this.$refs.refChildTaskDetailDlg.open({ action: action, id: id });
    },
    getList(num) {
      if (num) {
        this.page.current = num;
      }
      const { current, size } = this.page;
      let params = {
        current,
        size,
        ...this.formTool,
      };
      delete params.sumitTime;
      if (
        Array.isArray(this.formTool.taskStatusList) &&
        this.formTool.taskStatusList.length > 0
      ) {
        params.taskStatusList = this.formTool.taskStatusList;
      } else {
        params.taskStatusList = [];
      }
      if (
        Array.isArray(this.formTool.sumitTime) &&
        this.formTool.sumitTime.length === 2
      ) {
        params.startTime = dayjs(this.formTool.sumitTime[0]).format(
          "YYYY-MM-DD"
        );
        params.endTime = dayjs(this.formTool.sumitTime[1]).format("YYYY-MM-DD");
      }
      this.listLoading = true;
      contractDoTaskPageForCheck(params)
        .then((res) => {
          this.selectedList = [];
          this.tableData = res.records;
          this.page.total = res.total;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    handleRefresh() {
      this.getList(1);
    },
    handleReset() {
      for (let key in this.formTool) {
        this.formTool[key] = "";
      }
      this.formTool.taskStatusList = g_DefaultStatus;
      this.getList(1);
    },
    handleBack() {
      this.$router.back();
    },
    getTaskDetail() {
      contractTargetTaskDetail(this.taskId).then((data) => {
        if (data) {
          this.task = data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.classification {
  padding: 0px;
  height: calc(100%);
  display: flex;
  flex-direction: column;

  .header {
    height: auto;
    // height: 56px;
    line-height: 32px;
    display: flex;
    flex-wrap: wrap;
    // align-items: center;
    justify-content: space-between;
    padding: 16px 24px 16px 24px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  background: white;

  .center {
    margin-top: 16px;
    padding: 0 24px;
    // height: calc(100% - 131px);
    height: 0;
    flex: 1;

    ::v-deep {
      .zt__table {
        height: calc(100% - 60px);
      }
    }

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    .el-link {
      // margin: 5px;
    }
  }

  .table-op-col {
    display: flex;
    .el-link {
      & + .el-link {
        margin-left: 8px;
      }
    }
  }
}
</style>
